import React from 'react';
import { FD211 } from '../../../services/pwd210Api';
import { fmt } from '../helpers';

interface DetailTableProps {
  details: Partial<FD211>[];
  selectedRow: number;
  isEditing: boolean;
  totalItems: number;
  setSelectedRow: (idx: number) => void;
  getDetailField: (key: keyof FD211) => FD211[keyof FD211];
  setDetailField: (key: keyof FD211, value: FD211[keyof FD211]) => void;
  addDetailRow: () => void;
  deleteDetailRow: () => void;
}

const Pwd210DetailTable: React.FC<DetailTableProps> = React.memo(({
  details, selectedRow, isEditing, totalItems,
  setSelectedRow, getDetailField, setDetailField,
  addDetailRow, deleteDetailRow,
}) => {
  return (
    <div className="pwd210-tab2">
      {/* Grid (readonly per ui_spec note: Grid columns ENABLED=.F.) */}
      <div className="detail-table-wrapper">
        <table className="detail-table">
          <thead>
            <tr>
              <th style={{ width: 60 }} data-contract-field="fd211_02">項數</th>
              <th style={{ width: 160 }} data-contract-field="fd211_11">產品代號</th>
              <th style={{ width: 120 }} data-contract-field="fd211_12">入庫量</th>
              <th style={{ width: 140 }} data-contract-field="fd211_13">入庫金額</th>
            </tr>
          </thead>
          <tbody>
            {details.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', color: '#999' }}>無明細資料</td>
              </tr>
            ) : (
              details.map((row, i) => (
                <tr
                  key={i}
                  className={selectedRow === i ? 'selected' : ''}
                  onClick={() => setSelectedRow(i)}
                >
                  <td style={{ textAlign: 'center' }}>{row.fd211_02 ?? i + 1}</td>
                  <td>{row.fd211_11 || ''}</td>
                  <td style={{ textAlign: 'right' }}>{fmt(row.fd211_12 as number)}</td>
                  <td style={{ textAlign: 'right' }}>{fmt(row.fd211_13 as number)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Detail edit panel (below grid) */}
      {details.length > 0 && (
        <div className="detail-panel">
          <div className="form-grid">
            <label data-contract-field="fd211_11">產品代號</label>
            <div>
              <input
                type="text"
                style={{ width: 160 }}
                maxLength={12}
                disabled={!isEditing}
                value={getDetailField('fd211_11') as string}
                onChange={e => setDetailField('fd211_11', e.target.value)}
              />
            </div>

            <label data-contract-field="fd211_12">入庫量</label>
            <div>
              <input
                type="number"
                style={{ width: 120 }}
                disabled={!isEditing}
                value={getDetailField('fd211_12') as number || ''}
                onChange={e => setDetailField('fd211_12', parseFloat(e.target.value) || 0)}
              />
            </div>

            <label data-contract-field="fd211_13">入庫金額</label>
            <div>
              <input
                type="number"
                style={{ width: 140 }}
                disabled={!isEditing}
                value={getDetailField('fd211_13') as number || ''}
                onChange={e => setDetailField('fd211_13', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>

          {isEditing && (
            <div className="detail-actions">
              <button className="btn btn-sm" onClick={addDetailRow}>新增明細行</button>
              <button className="btn btn-sm btn-danger" onClick={deleteDetailRow} disabled={details.length <= 0}>刪除明細行</button>
            </div>
          )}
        </div>
      )}

      {/* 總項數（唯讀，存檔後計算更新） */}
      <div className="detail-summary">
        <label data-contract-field="fd210_21">總項數</label>
        <input type="text" readOnly value={totalItems} style={{ width: 60, textAlign: 'center' }} />
      </div>
    </div>
  );
});

Pwd210DetailTable.displayName = 'Pwd210DetailTable';

export default Pwd210DetailTable;
